import { SET_USER_DETAILS } from "../constants";

export const setUserDetails = (payload) => (
    {
        type: SET_USER_DETAILS,
        payload: payload
    }
);